/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Paper, Typography, Button } from '@material-ui/core';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import InputAdornment from '@material-ui/core/InputAdornment';
import MicIcon from '@material-ui/icons/Mic';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Rating from './Rating';
import RadioOptions from './RadioOptions';
// import Methodo from './Methodo';
import StrWeakTable from './StrWeakTable';
import InfluenceValuationTable from './InfluenceValuationTable';
import PeersTable from './PeersTable';

const animatedComponents = makeAnimated();

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, '')
});

const methodologies = [
  createOption('EV/Revenues'),
  createOption('EV/EBITDA'),
  createOption('EV/EBITA'),
  createOption('EV/(EBITDA - Capex)'),
  createOption('EV/(EBITDA - Capex - Tax)'),
  createOption('PER'),
  createOption('DCF'),
  createOption('Unlevered FCF yield (%)'),
  createOption('Equity FCF yield (%)')
];

const companyData = [
  createOption(
    'iShares MSCI All Country Asia Information Technology index Fund'
  ),
  createOption('Atlantic American Corporation'),
  createOption('Applied Optoelectronics, Inc.'),
  createOption('AAON, Inc.'),
  createOption('Apple Inc.'),
  createOption('Avalanche Biotechnologies, Inc.'),
  createOption('Atlas Air Worldwide Holdings'),
  createOption('iShares MSCI All Country Asia ex Japan Index Fund'),
  createOption('Aoxin Tianli Group, Inc.'),
  createOption('ABAXIS, Inc.'),
  createOption('Ameris Bancorp'),
  createOption('Cambium Learning Group, Inc.'),
  createOption('The Advisory Board Company'),
  createOption('Anchor BanCorp Wisconsin Inc.'),
  createOption('Abengoa, S.A.'),
  createOption('ARCA biopharma, Inc.'),
  createOption('ARCA biopharma, Inc.'),
  createOption('ABIOMED, Inc.'),
  createOption('Autobytel Inc.'),
  createOption('Abengoa Yield plc'),
  createOption('ACADIA Pharmaceuticals Inc.'),
  createOption('American Capital, Ltd.'),
  createOption('Arctic Cat Inc.'),
  createOption('Aceto Corporation'),
  createOption('Atlantic Coast Financial Corporation'),
  createOption('Acorn Energy, Inc.'),
  createOption('Arch Capital Group Ltd.'),
  createOption('Acadia Healthcare Company, Inc.'),
  createOption('Achillion Pharmaceuticals, Inc.'),
  createOption('ACI Worldwide, Inc.'),
  createOption('Axcelis Technologies, Inc.'),
  createOption('ACNB Corporation'),
  createOption('Acorda Therapeutics, Inc.'),
  createOption('Active Power, Inc.'),
  createOption('AcelRx Pharmaceuticals, Inc.'),
  createOption('American Capital Senior Floating, Ltd.'),
  createOption('Acasti Pharma, Inc.'),
  createOption('Actua Corporation'),
  createOption('Acacia Research Corporation'),
  createOption('Actions Semiconductor Co., Ltd.'),
  createOption('Acura Pharmaceuticals, Inc.'),
  createOption('iShares MSCI ACWI Index Fund'),
  createOption('iShares MSCI ACWI ex US Index Fund')
];

const useStyles = makeStyles((theme) => ({
  container: {
    width: '85%',
    margin: '0 auto'
  },
  textContainer: {
    margin: '1.5rem 0'
  },
  paperContainer: {
    padding: '1rem 4rem'
  },
  text: {
    fontFamily: 'PT sans',
    fontSize: '14px'
  },
  desc: {
    fontFamily: 'PT serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#252525',
    margin: '1rem 0'
  },
  instructions: {
    fontFamily: 'PT sans',
    fontSize: '16px'
  },
  valueInfo: {
    marginBottom: '2.5rem'
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  inputStrWeak: {
    marginTop: '.5rem',
    marginRight: '1rem',
    width: '35ch'
  },
  inputs: {
    display: 'flex',
    marginTop: '1.5rem',
    width: '100%'
  },
  strweak: {
    display: 'block',
    fontFamily: 'PT sans',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#252525'
  },
  add: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#002380',
    marginTop: '.3rem'
  },

  buttonDiv: {
    textAlign: 'right'
  },
  save: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem'
  },
  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderRadius: 0
  }
}));

// searchpeers style
const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 'none',
    padding: '7px 9px',
    marginTop: 3
  })
};

const FeedbackSaved = () => {
  const [options, setOptions] = useState([]);
  const [since, setSince] = useState(null);
  const [errorFetch, setErrorFetch] = useState('');
  const [errorPeer, setErrorPeer] = useState('');
  const [feedbackInfos, setFeedbackInfos] = useState({
    additional_comment: '',
    execution_of_strategy: 3,
    financial_position: 5,
    oovalue_comment: '',
    opinion_on_value: '',
    qom_comment: '',
    quality_of_management: 8
  });
  const [strengths, setStrengths] = useState([]);
  const [weaknesses, setWeaknesses] = useState([]);
  const [strength, setStrength] = useState('');
  const [weakness, setWeakness] = useState('');
  const [managementChallenges, setManagementChallenges] = useState([]);
  const [mngChallenge, setMngChallenge] = useState('');
  const [positiveIov, setPositiveIov] = useState([]);
  const [negativeIov, setNegativeIov] = useState([]);
  const [positiveInfluence, setPositiveInfluence] = useState([]);
  const [negativeInfluence, setNegativeInfluence] = useState([]);
  const [riskFactors, setRiskFactors] = useState([]);
  const [riskFactor, setRiskFactor] = useState('');
  const [valuationMethodos, setValuationMethodos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // const [checked, setChecked] = useState(false);

  const classes = useStyles();

  const {
    execution_of_strategy,
    financial_position,
    opinion_on_value,
    quality_of_management
  } = feedbackInfos;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          'http://drivee.localhost/api/feedbacks/findbyidpdf/77'
        );
        const { data } = response.data;
        setFeedbackInfos(data.Feedback.feedback_informations);
        setManagementChallenges(data.Feedback.management_challenges);
        setStrengths(data.Feedback.strengths);
        setWeaknesses(data.Feedback.weaknesses);
        setPositiveIov(data.Feedback.positive_influences_on_valuation);
        setNegativeIov(data.Feedback.negative_influences_on_valuation);
        setWeaknesses(data.Feedback.weaknesses);
        setRiskFactors(data.Feedback.risk_factors);
        setIsLoading(false);
      } catch (error) {
        setErrorFetch(error.message);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  // const handleChangeChecked = (e) => {
  //   setChecked(e.target.checked);
  // };

  const handleChangeOov = (e) => {
    setFeedbackInfos({
      ...feedbackInfos,
      opinion_on_value: e.target.value
    });
  };

  const onKeyPressStrength = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setStrengths([...strengths, { name: strength }]);
      setStrength('');
    }
  };

  const onKeyPressWeakness = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setWeaknesses([...weaknesses, { name: weakness }]);
      setWeakness('');
    }
  };

  const onKeyPressPositive = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setPositiveIov([...positiveIov, { name: positiveInfluence }]);
      setPositiveInfluence('');
    }
  };

  const onKeyPressNegative = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setNegativeIov([...negativeIov, { name: negativeInfluence }]);
      setNegativeInfluence('');
    }
  };

  const onKeyPressChallenge = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setManagementChallenges([
        ...managementChallenges,
        { name: mngChallenge }
      ]);
      setMngChallenge('');
    }
  };

  const onKeyPressRisk = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setRiskFactors([...riskFactors, { name: riskFactor }]);
      setRiskFactor('');
    }
  };

  const onClickDeleteStrength = (str) => {
    setStrengths(strengths.filter((st) => st.name !== str));
  };

  const onClickDeleteWeakness = (wkn) => {
    setWeaknesses(weaknesses.filter((wk) => wk.name !== wkn));
  };

  const onClickDeletePositive = (posInf) => {
    setPositiveIov(positiveIov.filter((pos) => pos.name !== posInf));
  };

  const onClickDeleteNegative = (negInf) => {
    setNegativeIov(negativeIov.filter((neg) => neg.name !== negInf));
  };

  const onClickDeleteChallenge = (chlg) => {
    setManagementChallenges(
      managementChallenges.filter((chal) => chal.name !== chlg)
    );
  };

  const onClickDeleteRisk = (riskFac) => {
    setRiskFactors(riskFactors.filter((rsk) => rsk.name !== riskFac));
  };

  const onSelectOption = (e) => {
    if (options.includes(e.label)) {
      setErrorPeer('Peer already added!');
    } else {
      setErrorPeer('');
      setOptions([...options, e.label]);
    }
  };

  const onClickDelete = (option) => {
    const updatedOptions = options.filter((opt) => opt !== option);
    setOptions(updatedOptions);
  };

  const handleChangeFeedbackInfos = ({ target: { name, value } }) => {
    setFeedbackInfos({ ...feedbackInfos, [name]: value });
  };

  return (
    <>
      {!isLoading ? (
        <div className={classes.container}>
          {errorFetch && <p style={{ color: 'red' }}>{errorFetch}</p>}

          <div className={classes.textContainer}>
            <Typography className={classes.text} color="initial" variant="p">
              Please fill in the following key questions in order to fully
              assess your appreciation of the investment case. You can also
              solicit a meeting with the company and its top management that
              could take place physically or via video-conference.
            </Typography>
            <br />
            <br />
            <Typography className={classes.text} color="initial" variant="p">
              We represent and certify that this information will be kept
              confidential to other investors and third parties to the exclusion
              of company's advisors that are also bound by a non-disclosure
              agreement.
            </Typography>
          </div>
          <Paper className={classes.paperContainer}>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Execution of strategy
              </Typography>
              <Typography className={classes.instructions}>
                Please rate management key strategic decisions communication and
                execution:
              </Typography>
              <Rating
                high="High quality"
                low="Low quality"
                onChange={(e, newValue) =>
                  setFeedbackInfos({
                    ...feedbackInfos,
                    execution_of_strategy: newValue
                  })
                }
                value={execution_of_strategy}
              />
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Financial position
              </Typography>
              <Typography className={classes.instructions}>
                Please rate management key strategic decisions communication and
                execution:
              </Typography>
              <Rating
                high="Strong"
                low="Weak"
                onChange={(e, newValue) =>
                  setFeedbackInfos({
                    ...feedbackInfos,
                    financial_position: newValue
                  })
                }
                value={financial_position}
              />
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Quality of management
              </Typography>
              <Typography className={classes.instructions}>
                Please rate management key strategic decisions communication and
                execution:
              </Typography>
              <Rating
                high="High quality"
                low="Low quality"
                onChange={(e, newValue) =>
                  setFeedbackInfos({
                    ...feedbackInfos,
                    quality_of_management: newValue
                  })
                }
                value={quality_of_management}
              />
              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    color="primary"
                    name="checked"
                    onChange={handleChangeChecked}
                  />
                }
                label="Additional comment (optional)"
              /> */}
              {/* <br />
              <Typography className={classes.instructions}>
                Additional comment (optional)
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-qomComments"
                  inputProps={{
                    'aria-label': 'qom comments'
                  }}
                  labelWidth={0}
                  multiline
                  name="qom comments"
                  onChange={(e) =>
                    setFeedbackInfos({
                      ...feedbackInfos,
                      qom_comment: e.target.value
                    })
                  }
                  rows={4}
                  rowsMax={4}
                  value={qom_comment}
                />
              </FormControl> */}
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Opinion on valuation proposed
              </Typography>
              <RadioOptions
                handleChange={handleChangeOov}
                options={['n/a', 'Cheap', 'Undervalued', 'Fair', 'Overvalued']}
                value={opinion_on_value}
              />
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Strenghts & weaknesses
              </Typography>
              <div>
                <Typography
                  className={classes.strweak}
                  color="initial"
                  variant="h6">
                  Strenghts
                </Typography>
                <FormControl className={classes.textField} variant="outlined">
                  <OutlinedInput
                    endAdornment={
                      <InputAdornment position="end">
                        <MicIcon />
                      </InputAdornment>
                    }
                    id="outlined-adornment-valuationWhy"
                    inputProps={{
                      'aria-label': 'strengths'
                    }}
                    labelWidth={0}
                    multiline
                    name="strengths"
                    onChange={(e) => setStrength(e.target.value)}
                    onKeyPress={onKeyPressStrength}
                    rows={2}
                    rowsMax={2}
                    value={strength}
                  />
                </FormControl>

                {strengths.length > 0 && (
                  <StrWeakTable
                    onClickDelete={onClickDeleteStrength}
                    strweak={strengths}
                  />
                )}
              </div>
              <br />
              <br />
              <div>
                <Typography
                  className={classes.strweak}
                  color="initial"
                  variant="h6">
                  Weaknesses
                </Typography>
                <FormControl className={classes.textField} variant="outlined">
                  <OutlinedInput
                    endAdornment={
                      <InputAdornment position="end">
                        <MicIcon />
                      </InputAdornment>
                    }
                    id="outlined-adornment-valuationWhy"
                    inputProps={{
                      'aria-label': 'weakness'
                    }}
                    labelWidth={0}
                    multiline
                    name="weakness"
                    onChange={(e) => setWeakness(e.target.value)}
                    onKeyPress={onKeyPressWeakness}
                    rows={2}
                    rowsMax={2}
                    value={weakness}
                  />
                </FormControl>
                {weaknesses.length > 0 && (
                  <StrWeakTable
                    onClickDelete={onClickDeleteWeakness}
                    strweak={weaknesses}
                  />
                )}
              </div>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Management challenges
              </Typography>
              <Typography className={classes.instructions}>
                Please list the few challenges that the management of the issuer
                would be facing:
              </Typography>
              <div>
                <FormControl className={classes.textField} variant="outlined">
                  <OutlinedInput
                    endAdornment={
                      <InputAdornment position="end">
                        <MicIcon />
                      </InputAdornment>
                    }
                    id="outlined-adornment-mngChal"
                    inputProps={{
                      'aria-label': 'mng_challenge'
                    }}
                    labelWidth={0}
                    multiline
                    name="mng_challenge"
                    onChange={(e) => setMngChallenge(e.target.value)}
                    onKeyPress={onKeyPressChallenge}
                    rows={2}
                    rowsMax={2}
                    value={mngChallenge}
                  />
                </FormControl>

                {managementChallenges.length > 0 && (
                  <InfluenceValuationTable
                    onClickDelete={onClickDeleteChallenge}
                    options={managementChallenges}
                  />
                )}
              </div>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Influence on valuation
              </Typography>
              <Typography className={classes.instructions}>
                Please list key factors that could positively or negatively
                impact valuation:
              </Typography>
              <br />
              <div>
                <div>
                  <Typography
                    className={classes.strweak}
                    color="initial"
                    variant="h6">
                    Positive impact
                  </Typography>
                  <FormControl className={classes.textField} variant="outlined">
                    <OutlinedInput
                      endAdornment={
                        <InputAdornment position="end">
                          <MicIcon />
                        </InputAdornment>
                      }
                      id="outlined-adornment-posInf"
                      inputProps={{
                        'aria-label': 'positive_influence'
                      }}
                      labelWidth={0}
                      multiline
                      name="positive_influence"
                      onChange={(e) => setPositiveInfluence(e.target.value)}
                      onKeyPress={onKeyPressPositive}
                      rows={2}
                      rowsMax={2}
                      value={positiveInfluence}
                    />
                  </FormControl>

                  {positiveIov.length > 0 && (
                    <InfluenceValuationTable
                      onClickDelete={onClickDeletePositive}
                      options={positiveIov}
                    />
                  )}
                </div>
                <br />
                <div>
                  <Typography
                    className={classes.strweak}
                    color="initial"
                    variant="h6">
                    Negative impact
                  </Typography>
                  <FormControl className={classes.textField} variant="outlined">
                    <OutlinedInput
                      endAdornment={
                        <InputAdornment position="end">
                          <MicIcon />
                        </InputAdornment>
                      }
                      id="outlined-adornment-negInf"
                      inputProps={{
                        'aria-label': 'negative_influence'
                      }}
                      labelWidth={0}
                      multiline
                      name="negative_influence"
                      onChange={(e) => setNegativeInfluence(e.target.value)}
                      onKeyPress={onKeyPressNegative}
                      rows={2}
                      rowsMax={2}
                      value={negativeInfluence}
                    />
                  </FormControl>

                  {negativeIov.length > 0 && (
                    <InfluenceValuationTable
                      onClickDelete={onClickDeleteNegative}
                      options={negativeIov}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Valuation methodologies
              </Typography>
              <Typography className={classes.instructions}>
                Select the top 3 methodologies to best evaluate the issuer:
              </Typography>
              <Select
                closeMenuOnScroll
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                onChange={(e) => setValuationMethodos(e)}
                options={methodologies}
                placeholder="select..."
                styles={customStyles}
              />
            </div>

            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Have you invested in peers?
              </Typography>
              <div>
                <Typography
                  className={classes.strweak}
                  color="initial"
                  variant="h6">
                  Select Peer
                </Typography>
                <Select
                  closeMenuOnSelect
                  components={animatedComponents}
                  onChange={onSelectOption}
                  options={companyData}
                  placeholder="type here..."
                  styles={customStyles}
                />

                {options.length > 0 && (
                  <PeersTable
                    onClickDelete={onClickDelete}
                    options={options}
                    setSince={(date) =>
                      setSince(moment(date).format('MMMM YYYY'))
                    }
                    since={since}
                  />
                )}
                {errorPeer && <p className={classes.error}>{errorPeer}</p>}
              </div>
            </div>

            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Your appreciation of the risk factors
              </Typography>
              <Typography className={classes.instructions}>
                Please list the risk factors that in your view are the most
                relevant
              </Typography>
              <div>
                <FormControl className={classes.textField} variant="outlined">
                  <OutlinedInput
                    endAdornment={
                      <InputAdornment position="end">
                        <MicIcon />
                      </InputAdornment>
                    }
                    id="outlined-adornment-rskFact"
                    inputProps={{
                      'aria-label': 'risk_factor'
                    }}
                    labelWidth={0}
                    multiline
                    name="risk factor"
                    onChange={(e) => setRiskFactor(e.target.value)}
                    onKeyPress={onKeyPressRisk}
                    rows={2}
                    rowsMax={2}
                    value={riskFactor}
                  />
                </FormControl>
                {riskFactors.length > 0 && (
                  <InfluenceValuationTable
                    onClickDelete={onClickDeleteRisk}
                    options={riskFactors}
                  />
                )}
              </div>
            </div>
            {/* <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Additional comment (optional)
              </Typography>
              <Typography className={classes.instructions}>
                Please write here any additional comment that you deem relevant
                or useful:
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuationCom"
                  inputProps={{
                    'aria-label': 'influence'
                  }}
                  labelWidth={0}
                  multiline
                  name="comments"
                  onChange={handleChangeFeedbackInfos}
                  rows={4}
                  rowsMax={4}
                  value={additional_comment}
                />
              </FormControl>
            </div> */}
            <div className={classes.buttonDiv}>
              <Button
                className={classes.save}
                color="primary"
                onClick={() => console.log({ ...feedbackInfos, sent: false })}
                variant="outlined">
                Save answers
              </Button>
              <Button
                className={classes.send}
                color="primary"
                onClick={() => console.log({ ...feedbackInfos, sent: true })}
                variant="contained">
                Send feedback
              </Button>
            </div>
          </Paper>
        </div>
      ) : (
        <LinearProgress />
      )}
    </>
  );
};

export default FeedbackSaved;
